'use strict';

(function () {
	// How far below the viewport top a builder step should land: under the
	// sticky header and the sticky "Your selection" strip, plus a little air.
	// Shared with product-builder-2.js, product-builder-step2.liquid and
	// sticky-strip.liquid through window.brandlerStepScrollOffset.
	function getStepScrollOffset() {
		const header = parseFloat(
			getComputedStyle(document.documentElement).getPropertyValue('--header-height')
		);
		const strip = document.querySelector('.sticky-selection-section');
		if (Number.isNaN(header)) return 150;
		return header + (strip ? strip.offsetHeight : 0) + 16;
	}
	window.brandlerStepScrollOffset = getStepScrollOffset;

	document.querySelectorAll('.section-product-builder .custom-option-section .functional').forEach(el => {
		el.addEventListener('click', () => {
			const builder = document.querySelector('.section-product-builder');
			const ikeaStepSection = document.querySelector('.custom-option-section.IKEA-step');

			const allSections = Array.from(builder.querySelectorAll('.custom-option-section'));
			const customSection = document.querySelector('.main-product-custom');
			const currentSection = el.closest('.custom-option-section');
			const optionName = el.dataset.optionName;
			const optionValue = el.dataset.optionValue;

			const currentIndex = allSections.indexOf(currentSection);

			allSections.forEach((sec, idx) => {
				if (idx > currentIndex) sec.classList.remove('active');
			});

			allSections.forEach((sec, idx) => {
				if (idx <= currentIndex) sec.classList.add('active');
			});

			currentSection.querySelectorAll('.functional').forEach(f => f.classList.remove('selected'));
			el.classList.add('selected');

			const nextSection = allSections[currentIndex + 1];
			if (nextSection) nextSection.classList.add('active');



			if (optionName === 'Custom' && customSection) {
				customSection.style.display = 'block';
				if (ikeaStepSection) ikeaStepSection.classList.remove('active');
			}

			if (optionName === 'Material') {
				document.querySelectorAll('input#material[type="hidden"][name="properties[Material]"]').forEach(input => {
					input.value = optionValue || '';
				});
			}

		});
	});

	/* --------------------------------------------------------------------
	   Doors journey (#341): Route → Finish → Guide → Branch.

	   The route (Standard sizes = IKEA, Custom size = Custom) is the
	   door-type choice rendered at the top of the builder. The generic
	   click handlers above (and the copy in product-builder-2.js) open the
	   next step and show a branch straight away; syncRouteFlow runs after
	   them from a document-level listener and puts the page back in the
	   journey's order:
	     - finish shows once a route is picked;
	     - guide and the route's branch show once a finish is picked too.
	   Switching route keeps the chosen finish.
	   -------------------------------------------------------------------- */
	const routeBuilder = document.querySelector('[data-route-builder]');

	function getSelectedRoute() {
		const selected = routeBuilder?.querySelector('.route-option-section door-type.selected');
		return selected ? selected.dataset.optionName : '';
	}

	function getRouteBranch(route) {
		if (route === 'IKEA') return document.querySelector('.custom-option-section.IKEA-step');
		if (route === 'Custom') {
			return document.getElementById('custom-calculator') || document.querySelector('.main-product-custom');
		}
		return null;
	}

	function syncRouteFlow() {
		if (!routeBuilder) return;

		const route = getSelectedRoute();
		const branchReady = route !== '' && isFinishSelected();

		routeBuilder.dataset.route = route;
		routeBuilder.querySelectorAll('.colors-option-section').forEach((section) => {
			section.classList.toggle('active', route !== '');
		});
		routeBuilder.querySelectorAll('.custom-option-section.information').forEach((section) => {
			section.classList.toggle('active', branchReady);
		});

		const ikeaStep = document.querySelector('.custom-option-section.IKEA-step');
		const customSection = document.querySelector('.main-product-custom');
		if (ikeaStep) ikeaStep.classList.toggle('active', branchReady && route === 'IKEA');
		if (customSection) customSection.style.display = branchReady && route === 'Custom' ? 'block' : 'none';

		// "Continue to … Layout" in the finish step unlocks together with the guide.
		routeBuilder.querySelectorAll('[data-layout-continue]').forEach((button) => {
			button.disabled = !branchReady;
			const wrapper = button.closest('[data-layout-continue-wrapper]');
			if (wrapper) wrapper.classList.toggle('is-ready', branchReady);
		});
	}

	function getFinishStep() {
		return routeBuilder ? routeBuilder.querySelector('.colors-option-section.active') : null;
	}

	if (routeBuilder) {
		syncRouteFlow();

		// Bubble phase on document: runs after the per-element step handlers.
		document.addEventListener('click', (event) => {
			if (!(event.target instanceof Element)) return;
			const routeCard = event.target.closest('.route-option-section door-type');
			const finishCard = event.target.closest('.colors-option-section .functional');
			if (!routeCard && !finishCard) return;

			syncRouteFlow();

			// Every route pick (Standard / Custom size) brings the finish step into
			// view. Programmatic clicks (switchRoute, keyboard) scroll on their own.
			if (routeCard && event.isTrusted) {
				const finishSection = getFinishStep();
				if (finishSection) scrollToStep(finishSection);
			}
		});

		routeBuilder.querySelectorAll('.route-option-section door-type').forEach((card) => {
			card.addEventListener('keydown', (event) => {
				if (event.key !== 'Enter' && event.key !== ' ') return;
				event.preventDefault();
				card.click();
				const finishSection = getFinishStep();
				if (finishSection) scrollToStep(finishSection);
			});
		});

		// "Continue to … Layout ↓": scroll to the layout guide once a finish is picked.
		routeBuilder.querySelectorAll('[data-layout-continue]').forEach((button) => {
			button.addEventListener('click', () => {
				if (button.disabled) return;
				const layoutStep = routeBuilder.querySelector('.custom-option-section.information.active');
				if (layoutStep) scrollToStep(layoutStep);
			});
		});
	}

	/* --------------------------------------------------------------------
	   Eased step scroll.

	   Native `behavior: 'smooth'` runs at the browser's own (fast) speed and
	   can't be tuned, so builder steps scroll with a short ease-in-out
	   animation instead. The target is re-measured every frame, so steps that
	   open or images that load mid-scroll don't make it land short. The global
	   `html { scroll-behavior: smooth }` (sticky-strip.liquid) is switched off
	   for the duration, otherwise every frame would start its own native
	   smooth scroll. A wheel / touch from the shopper cancels the animation.
	   -------------------------------------------------------------------- */
	let activeStepScroll = null;

	function getStepTop(targetEl) {
		const top = targetEl.getBoundingClientRect().top + window.scrollY - getStepScrollOffset();
		const maxTop = document.documentElement.scrollHeight - window.innerHeight;
		return Math.max(0, Math.min(top, maxTop));
	}

	function easeInOutCubic(t) {
		return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
	}

	function scrollToStep(targetEl) {
		if (!targetEl) return;
		if (activeStepScroll) activeStepScroll.cancel();

		const root = document.documentElement;
		const previousBehavior = root.style.scrollBehavior;
		const startY = window.scrollY;
		const distance = Math.abs(getStepTop(targetEl) - startY);
		const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		root.style.scrollBehavior = 'auto';

		if (reduceMotion || distance < 2) {
			window.scrollTo(0, getStepTop(targetEl));
			root.style.scrollBehavior = previousBehavior;
			return;
		}

		// ~0.8s for a typical step jump, never shorter than 0.7s or longer than 1.2s.
		const duration = Math.min(1200, Math.max(700, 500 + distance * 0.35));
		const interruptEvents = ['wheel', 'touchstart'];
		let startTime = null;
		let frameId = 0;
		let finished = false;

		function cancel() {
			if (finished) return;
			finished = true;
			cancelAnimationFrame(frameId);
			interruptEvents.forEach((type) => window.removeEventListener(type, cancel));
			root.style.scrollBehavior = previousBehavior;
			if (activeStepScroll === controller) activeStepScroll = null;
		}

		function step(now) {
			if (finished) return;
			if (startTime === null) {
				startTime = now;
				// Added on the first frame so the click / key that started the
				// scroll can't cancel it.
				interruptEvents.forEach((type) => window.addEventListener(type, cancel, { passive: true }));
			}
			const progress = Math.min(1, (now - startTime) / duration);
			const targetY = getStepTop(targetEl);
			window.scrollTo(0, startY + (targetY - startY) * easeInOutCubic(progress));
			if (progress < 1) {
				frameId = requestAnimationFrame(step);
			} else {
				cancel();
			}
		}

		const controller = { cancel };
		activeStepScroll = controller;
		frameId = requestAnimationFrame(step);
	}
	window.brandlerScrollToStep = scrollToStep;

	// Switches the route from a link inside a branch (IKEA step "Custom Size",
	// calculator "IKEA Doors", "View Custom Doors") and lands on the new branch.
	function switchRoute(routeName) {
		const target = document.querySelector(`door-type[data-option-name="${routeName}"]`);
		if (!target) return;
		target.click();
		const branch = getRouteBranch(routeName);
		// No finish yet means the branch is still hidden: go to the finish step.
		const destination =
			branch && branch.offsetParent !== null ? branch : document.querySelector('.colors-option-section.active');
		if (destination) scrollToStep(destination);
	}
	window.brandlerSwitchDoorRoute = switchRoute;

	document.getElementById('custom-way')?.addEventListener('click', (event) => {
		event.preventDefault();
		setTimeout(() => {
			switchRoute('Custom');
		}, 200);
	});

	// Reverse of #custom-way: the Custom Doors calculator links back to the IKEA
	// step. Only revealed when this builder actually offers IKEA doors.
	const ikeaDoorType = document.querySelector('door-type[data-option-name="IKEA"]');
	const ikeaWay = document.getElementById('ikea-way');
	if (ikeaDoorType && ikeaWay) {
		ikeaWay.closest('.custom-calc-header__nav')?.classList.remove('hidden');
		ikeaWay.addEventListener('click', (event) => {
			event.preventDefault();
			setTimeout(() => {
				switchRoute('IKEA');
			}, 200);
		});
	}

	document.querySelectorAll('.filter-select').forEach(select => {
		select.addEventListener('change', () => {
			const filterValue = select.value.toLowerCase();
			const container = document.querySelector('.ikea-products');
			if (!container) return;

			const items = container.querySelectorAll('.grid__item');

			items.forEach(item => {
				const dataFilter = item.getAttribute('data-filter')?.toLowerCase() || '';
				if (filterValue === 'all' || dataFilter.includes(filterValue)) {
					item.style.display = '';
				} else {
					item.style.display = 'none';
				}
			});
		});
	});

	document.querySelector('.new-group')?.addEventListener('click', (e) => {
		e.preventDefault();
		const groupInputs = document.querySelectorAll('input#type[type="hidden"][name="properties[Group]"]');

		groupInputs.forEach(input => {
			let currentValue = parseInt(input.value) || 0;
			input.value = currentValue + 1;
		});
	});

	document.querySelectorAll('.set_endings .radio_group input[type="radio"]').forEach(radio => {
		radio.addEventListener('change', (e) => {
			const endingInfo = e.target.closest('.product-endings')?.querySelector('.endings_setup');
			if (!endingInfo) return;

			if (radio.checked) {
				if (radio.value === 'yes') {
					endingInfo.style.display = 'block';
				} else if (radio.value === 'no') {
					endingInfo.style.display = 'none';
				}
			}
		});
	});

	document.querySelectorAll('.set_hadles .radio_group input[type="radio"]').forEach(radio => {
		radio.addEventListener('change', (e) => {
			const endingInfo = e.target.closest('.product-endings')?.querySelector('.handles_setup');
			if (!endingInfo) return;

			if (radio.checked) {
				if (radio.value === 'yes') {
					endingInfo.style.display = 'block';
				} else if (radio.value === 'no') {
					endingInfo.style.display = 'none';
				}
			}
		});
	});

	document.querySelectorAll('.circle').forEach(circle => {
		circle.addEventListener('click', function() {
			if (this.classList.contains('active')) {
				this.classList.remove('active');
			} else {
				this.classList.add('active');
			}

			document.getElementById('properties').value = this.classList[1];
		});
	});

	document.querySelectorAll('.brackets-select input[type="radio"][name="bracket"]').forEach(radio => {
		radio.addEventListener('click', () => {
			document.querySelector('.main-product-custom').style.display = 'block';

			if (radio.value === 'Yes') {
				const trueRadio = document.querySelector('input[data-identifier="Bracket"][data-val="1"]');
				if (trueRadio) {
					trueRadio.click();
				} else {
					document.addEventListener('DOMContentLoaded', () => {
						const trueRadioDelayed = document.querySelector('input[data-identifier="Bracket"][data-val="1"]');
						if (trueRadioDelayed) trueRadioDelayed.click();
					});
				}
			} else if (radio.value === 'No') {
				const falseRadio = document.querySelector('input[data-identifier="Bracket"][data-val="0"]');
				if (falseRadio) {
					falseRadio.click();
				} else {
					document.addEventListener('DOMContentLoaded', () => {
						const falseRadioDelayed = document.querySelector('input[data-identifier="Bracket"][data-val="0"]');
						if (falseRadioDelayed) falseRadioDelayed.click();
					});
				}
			}
		});
	});

	document.querySelectorAll('.ending-position').forEach(radio => {
	  radio.addEventListener('click', () => {

			const brackets = document.querySelectorAll('.brackets-select');
	    if (brackets.length == 0) {
				document.querySelector('.main-product-custom').style.display = 'block';
	    }
	  })
	})



	if (!customElements.get('product-setup')) {
		class ProductSetup extends HTMLElement {
			constructor() {
				super();
				this.enableSetup = false;
				this.createFormInput = this.createFormInput.bind(this);
				this.updateFormInput = this.updateFormInput.bind(this);
			}

			connectedCallback() {
				this.addEventListeners();
			}

			disconnectedCallback() {
				this.removeEventListeners();
			}
		}

		ProductSetup.prototype.addEventListeners = function(){
			this.addEventListener('click', this.onListClickHandler);
			this.addEventListener('click', this.onListOptionClickHandler);
		};


		ProductSetup.prototype.createFormInput = function(id, value) {
			if (!this.form) {
				this.form = document.querySelector('.product__info-container .product-form .form')
			}
			if (!this.form || !id || !value) return
			if (this.form.querySelector(`input[name="${id}"`)) return;

			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = id;
			input.value = value;
			input.className = `${this.dataset.property}_input`;
			this.form.appendChild(input);
		}

		ProductSetup.prototype.updateFormInput = function(id, value) {
			if (!this.form) {
				this.form = document.querySelector('.product__info-container .product-form .form')
			}
			if (!this.form || !id || !value) return

			const input = this.form.querySelector(`[name="${id}"]`);
			if (!input) return
			input.value = value;
		}

		ProductSetup.prototype.form = document.querySelector('.product__info-container .product-form .form')

		ProductSetup.prototype.removeEventListeners = function() {
			this.removeEventListener('click', this.onListClickHandler);
			this.removeEventListener('click', this.onListOptionClickHandler);
		}

		ProductSetup.prototype.onListClickHandler = function(e) {
			const target = getEventTarget('[data-component="option"]', e.target);
			if (!target || target?.classList?.contains('active')) return

			const value = target?.dataset?.value || '';
			const edgesSetup = target.closest('[data-component="options-list"]')
			const activeEdge = edgesSetup?.querySelector('[data-component="option"].active')

			if (!target.querySelector('[data-component="option-radio"]')) {
				if(activeEdge) activeEdge.classList.remove('active');
				edgesSetup?.querySelector('[data-component="option-radio"].active')?.classList.remove('active');
				target.classList.add('active');
				this.updateFormInput(edgesSetup.id, value)
			}
		}

		ProductSetup.prototype.onListOptionClickHandler = function(e) {
			const target = getEventTarget('[data-component="option-radio"]', e.target);
			if (!target || target?.classList?.contains('active')) return

			const value = target?.dataset?.value || '';
			const edgesSetup = target.closest('[data-component="options-list"]')
			const activeEdge = target.closest('[data-component="options-list"]')?.querySelector('[data-component="option"].active')

			if(activeEdge) activeEdge.classList.remove('active');

			const edgeType = target.closest('[data-component="option"]');

			if (edgeType) {
				edgeType.classList.add('active');
				edgeType.querySelector('[data-component="option-radio"].active')?.classList.remove('active');
			}

			target.classList.add('active');
			this.updateFormInput(edgesSetup.id, value)
		}

		customElements.define('product-setup', ProductSetup);
	}


	if (!customElements.get('atc-submit')) {
		class AtcSubmit extends HTMLElement {
			constructor() {
				super();
				this.onClick = this.onClick.bind(this);
				this.onKeyDown = this.onKeyDown.bind(this);
			}

			connectedCallback() {
				this.addEventListeners();
				this.setAttribute('tabindex', '0');
			}

			disconnectedCallback() {
				this.removeEventListeners();
			}

			addEventListeners() {
				this.addEventListener('click', this.onClick);
				this.addEventListener('keydown', this.onKeyDown);
			}

			removeEventListeners() {
				this.removeEventListener('click', this.onClick);
				this.removeEventListener('keydown', this.onKeyDown);
			}

			onClick() {
				this.atcBtn = document.querySelector('.product__info-container .product-form .form .product-form__submit');
				if (!this.atcBtn) return;

				this.classList.add('loading'); // Add loading class
				this.classList.add('disabled'); // Add disabled class
				this.atcBtn.click(); // Trigger the actual button click
			}

			onKeyDown(e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault(); // Prevent the default action for Enter/Space
					this.onClick(); // Trigger the click method
				}
			}
		}

		customElements.define('atc-submit', AtcSubmit);
	}

	/* --------------------------------------------------------------------
	   Finish gate.

	   The finish step is the first decision in the builder, but nothing used
	   to stop a shopper reaching an add-to-cart control with no finish
	   selected — the door then landed in the cart with an empty Material /
	   Color property. These listeners run in the capture phase so they fire
	   before the add-to-cart handlers (product-builder-2.js, product-form.js)
	   and the fly-to-cart animation, and stop the event outright.
	   -------------------------------------------------------------------- */
	const FINISH_ADD_SELECTOR = [
		'.door-builder-add-to-bag',
		'.main-product-custom .product-form__submit',
	].join(', ');

	function getFinishSections() {
		return Array.from(document.querySelectorAll('.colors-option-section'));
	}

	function isFinishSelected() {
		const sections = getFinishSections();
		// No finish step on this page, so there is nothing to enforce.
		if (!sections.length) return true;

		return sections.some((section) => {
			const input = section.querySelector('.input-cart-option[name="color"]');
			if (input && input.value.trim() !== '') return true;
			return section.querySelector('.functional.selected') !== null;
		});
	}

	function showFinishError() {
		const sections = getFinishSections();
		const section = sections.find((s) => s.offsetParent !== null) || sections[0];
		if (!section) return;

		section.classList.add('active');
		const message = section.querySelector('[data-finish-error]');
		if (message) message.hidden = false;

		scrollToStep(section);
	}

	function clearFinishError() {
		document.querySelectorAll('[data-finish-error]').forEach((message) => {
			message.hidden = true;
		});
	}

	document.addEventListener(
		'click',
		(event) => {
			if (!(event.target instanceof Element)) return;

			if (event.target.closest('.colors-option-section .functional')) {
				clearFinishError();
				return;
			}

			if (!event.target.closest(FINISH_ADD_SELECTOR)) return;
			if (isFinishSelected()) return;

			event.preventDefault();
			event.stopPropagation();
			showFinishError();
		},
		true
	);

	document.addEventListener(
		'submit',
		(event) => {
			const form = event.target.closest('.main-product-custom form[data-type="add-to-cart-form"]');
			if (!form) return;
			if (isFinishSelected()) return;

			event.preventDefault();
			event.stopPropagation();
			showFinishError();
		},
		true
	);
})();
